import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Shared/Input';
import { notify } from '../Shared/toast';

function AuthForm({ type, onSubmit, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold text-center mb-6">
          {type === 'login' ? 'LOGIN' : 'SIGN UP'}
          <span className="text-sm text-gray-500">(DEMO MODE)</span>
        </h2>

        <form onSubmit={onSubmit} className="flex flex-col space-y-5 justify-center items-center">
          <Input
            type="email"
            placeholder="Email"
            onChange={(e) => notify.success(e.target.value)} // Replace with real handler
            className="w-full"
          />
          <Input
            type="password"
            placeholder="Password"
            className="w-full"
          />

          {children}
        </form>
      </div>
    </div>
  );
}

// Prop validation
AuthForm.propTypes = {
  type: PropTypes.oneOf(['login', 'signup']).isRequired,
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
};

AuthForm.defaultProps = {
  children: null,
};

export default AuthForm;
